import $ from './utils/NodeList.js'
// let coerce = {
//   header: 'boolean'
// }

export default {
  props: {
    content: { type: String },
    effect: { type: String, default: 'fade' },
    header: { type: Boolean, default: true },
    placement: { type: String, default: 'top' },
    title: { type: String },
    trigger: { type: String },
  },
  data() {
    return {
      position: {
        top: 0,
        left: 0,
      },
      show: false,
    }
  },
  methods: {
    toggle(e) {
      if (e && this.trigger === 'contextmenu') e.preventDefault()
      if (!(this.show = !this.show)) {
        return
      }
      const self = this
      setTimeout(() => {
        const popover = self.$refs.popover
        const trigger = self.$refs.trigger.children[0]
        switch (self.placement) {
          case 'top':
            self.position.left =
              trigger.offsetLeft -
              popover.offsetWidth / 2 +
              trigger.offsetWidth / 2
            self.position.top = trigger.offsetTop - popover.offsetHeight
            break
          case 'left':
            self.position.left = trigger.offsetLeft - popover.offsetWidth
            self.position.top =
              trigger.offsetTop +
              trigger.offsetHeight / 2 -
              popover.offsetHeight / 2
            break
          case 'right':
            self.position.left = trigger.offsetLeft + trigger.offsetWidth
            self.position.top =
              trigger.offsetTop +
              trigger.offsetHeight / 2 -
              popover.offsetHeight / 2
            break
          case 'bottom':
            self.position.left =
              trigger.offsetLeft -
              popover.offsetWidth / 2 +
              trigger.offsetWidth / 2
            self.position.top = trigger.offsetTop + trigger.offsetHeight
            break
          default:
            console.warn('Wrong placement prop')
        }
        popover.style.top = self.position.top + 'px'
        popover.style.left = self.position.left + 'px'
      }, 0)
    },
  },
  mounted() {
    let trigger = this.$refs.trigger
    if (!trigger)
      return console.error(
        'Could not find trigger v-el in your component that uses popoverMixin.',
      )

    if (this.trigger === 'focus' && !~trigger.tabIndex) {
      trigger = $('a,input,select,textarea,button', trigger)
      if (!trigger.length) {
        trigger = null
      }
    }
    if (trigger) {
      const events = {
        contextmenu: 'contextmenu',
        hover: 'mouseleave mouseenter',
        focus: 'blur focus',
      }
      $(trigger).on(events[this.trigger] || 'click', this.toggle)
      this._trigger = trigger
    }
  },
  beforeDestroy() {
    if (this._trigger) $(this._trigger).off()
  },
}
